/**
 * SignupRoutes.tsx — every public route added by the multi-tenant sign-up work,
 * in ONE place so the launch switch is a single gate.
 *
 * ⛔ RENDERED ONLY WHEN `REACT_APP_SIGNUP_ENABLED` IS ON. App.tsx gates it:
 *    `{isSignupEnabled() && signupRoutes()}`. With the switch OFF (the default)
 *    NONE of these paths is registered, so each falls through to the app's
 *    normal not-found behaviour (the `path="*"` catch-all). That is what lets
 *    `main` deploy without exposing the unfinished sign-up.
 *
 * ⚠️ IT IS A FUNCTION THAT RETURNS A FRAGMENT, NOT A COMPONENT, ON PURPOSE:
 *    React Router only accepts `<Route>` or `<React.Fragment>` as children of
 *    `<Routes>`; a custom `<Component />` there throws. Calling `signupRoutes()`
 *    yields the fragment directly.
 *
 * With the switch ON, nothing here changes: same routes, same pages.
 */

import { lazy } from 'react';
import { Route } from 'react-router-dom';

const CrmPricingPage       = lazy(() => import('../CrmPricingPage'));
const SignupPage           = lazy(() => import('./SignupPage'));
const VerifyPage           = lazy(() => import('./VerifyPage'));
const CompanyExistsPage    = lazy(() => import('./CompanyExistsPage'));
const RequestSentPage      = lazy(() => import('./RequestSentPage'));
const ProfileQuestionsPage = lazy(() => import('./ProfileQuestionsPage'));
const WelcomePage          = lazy(() => import('./WelcomePage'));
const LoginHandoffPage     = lazy(() => import('../LoginHandoffPage'));
const AcceptInvitePage     = lazy(() => import('../AcceptInvitePage'));
const PlansComingSoonPage  = lazy(() => import('../PlansComingSoonPage'));
const TrialEndedPage       = lazy(() => import('../TrialEndedPage'));
const WorkspaceNotFoundPage = lazy(() => import('../WorkspaceNotFoundPage'));

export function signupRoutes() {
  return (
    <>
      <Route path="/pricing/crm"               element={<CrmPricingPage />} />
      <Route path="/signup"                    element={<SignupPage />} />
      <Route path="/signup/verify"             element={<VerifyPage />} />
      <Route path="/signup/company-exists"     element={<CompanyExistsPage />} />
      <Route path="/signup/request-sent"       element={<RequestSentPage />} />
      <Route path="/signup/profile-questions"  element={<ProfileQuestionsPage />} />
      <Route path="/signup/welcome"            element={<WelcomePage />} />
      <Route path="/login/handoff"             element={<LoginHandoffPage />} />
      <Route path="/accept-invite"             element={<AcceptInvitePage />} />
      <Route path="/plans-opening-soon"        element={<PlansComingSoonPage />} />
      <Route path="/trial-ended"               element={<TrialEndedPage />} />
      <Route path="/w/:slug"                   element={<WorkspaceNotFoundPage />} />
    </>
  );
}